import React from 'react'

const PrepaidCard = () => {
  return (
    <div>
      PrepaidCard
    </div>
  )
}

export default PrepaidCard
